import Logo from 'components/common/Logo'
import { useApp, useAuth, useTheme } from 'hooks'
import { LogOut, Moon, SquareArrowOutUpRight, Sun, UserRound } from 'lucide-react'
import moment from 'moment'
import { Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { NavLink } from 'react-router'
import QuickSightTopic from '../../Reporting/BusinessIntelligence/components/QuickSightTopic'
import './TopNav.scss'

function TopNav() {
  const { user, clearUser } = useAuth()
  const { version, packagingType, lastRunTime, isQEnabled } = useApp()
  const { theme, setTheme } = useTheme()

  const isLocalhost = window.location.hostname === 'localhost'

  return (
    <Navbar
      sticky="top"
      bg={theme === 'dark' ? 'dark' : 'white'}
      className={`mb-3 py-1 ${theme === 'dark' ? 'shadow-lg' : 'shadow-sm'}`}
    >
      <div className="container-fluid px-5 justify-content-between gap-3">
        <Navbar.Brand>
          <NavLink to="/">
            <Logo alt="logo" height={40} />
          </NavLink>
        </Navbar.Brand>

        <div className="position-relative w-100">{isQEnabled && !isLocalhost && <QuickSightTopic />}</div>

        <Navbar.Collapse className="flex-grow-0">
          <Nav className="align-items-center">
            <Navbar.Text className="text-end ">
              <strong className="text-sm fw-semibold text-nowrap">Welcome {user?.username}</strong>

              <div className="text-xs text-nowrap">
                {lastRunTime && `AWS spend as of ${moment.utc(lastRunTime).local().format('MM/DD/yyyy hh:mm A')}`}
              </div>
            </Navbar.Text>
            <NavDropdown
              title={
                <div className="avatar">
                  <UserRound size={20} />
                </div>
              }
              className="user-dropdown nav-avatar-item"
            >
              <NavDropdown.Item
                as="a"
                href="https://docs.finopscenter.com/personas-roles-activities"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SquareArrowOutUpRight size={16} className="me-2" />
                Documentation
              </NavDropdown.Item>

              <NavDropdown.Item onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}>
                {theme === 'dark' ? (
                  <div>
                    <Sun size={16} className="me-2" />
                    Light mode
                  </div>
                ) : (
                  <div>
                    <Moon size={16} className="me-2" />
                    Dark mode
                  </div>
                )}
              </NavDropdown.Item>

              <NavDropdown.Item onClick={clearUser}>
                <LogOut size={16} className="me-2" /> Log out
              </NavDropdown.Item>

              <NavDropdown.Divider />

              <NavDropdown.ItemText>
                <div>Release v{version}</div>
                <div>Version: {packagingType}</div>
              </NavDropdown.ItemText>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  )
}
export default TopNav
